import React from "react";
import { Card, CardBody, CardHeader } from "reactstrap";

interface PostUser {
  id: number;
  name: string;
  email?: string;
  role?: string;
}

interface PostItem {
  id: number;
  title: string;
  content?: string;
  campus?: string;
  created_at: string;
  coverUrl?: string;
  thumbnailUrl?: string;
  user?: PostUser;
}

interface PostProps {
  data: PostItem[];
}

const formatDate = (iso: string) => {
  if (!iso) return "";
  const date = new Date(iso);
  if (Number.isNaN(date.getTime())) return "";
  return date.toLocaleDateString(undefined, {
    year: "numeric",
    month: "short",
    day: "numeric",
  });
};

const Post = ({ data }: PostProps) => {
  return (
    <Card>
      <CardHeader className="bg-transparent d-flex align-items-center justify-content-between">
        <h5 className="card-title mb-0">Noticeboard</h5>
        <small className="text-muted">{data.length} post{data.length === 1 ? "" : "s"}</small>
      </CardHeader>
      <CardBody>
        {data.length === 0 && (
          <p className="text-muted mb-0">No posts available.</p>
        )}
        {data.map((post) => {
          const image = post.thumbnailUrl || post.coverUrl;
          return (
            <Card key={post.id} className="mb-3 border shadow-sm">
              {image && (
                <img
                  src={image}
                  alt={post.title}
                  className="card-img-top"
                  style={{ width: "100%", maxHeight: 220, objectFit: "cover" }}
                />
              )}
              <CardBody>
                <div className="d-flex align-items-start justify-content-between mb-2">
                  <h6 className="mb-0">{post.title}</h6>
                  {post.campus && post.campus !== "ALL" && (
                    <span className="badge bg-soft-primary text-primary ms-2">
                      {post.campus}
                    </span>
                  )}
                </div>
                {post.content && post.content.trim().length > 0 && (
                  <p className="text-muted mb-2" style={{ whiteSpace: "pre-line" }}>
                    {post.content}
                  </p>
                )}
                <div className="d-flex align-items-center text-muted small">
                  <i className="fas fa-user-circle me-1"></i>
                  <span className="me-3">{post.user?.name || "Unknown"}</span>
                  <i className="fas fa-clock me-1"></i>
                  <span>{formatDate(post.created_at)}</span>
                </div>
              </CardBody>
            </Card>
          );
        })}
      </CardBody>
    </Card>
  );
};

export default Post;
